import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  endorsementsContainer: {
    background: theme.colorPalette.green_90,
    width: '100%',
    margin: 0,
    padding: theme.spacing(6, 8),
    borderRadius: theme.sizes.roundCorners
  },
  marginBottom: {
    marginBottom: theme.spacing(2)
  },
  header: {
    borderTop: `1px solid ${theme.colorPalette.green_75_op_40}`,
    padding: theme.spacing(2, 0),
    width: '100%'
  },
  checkboxContainer: {
    marginTop: theme.spacing(3)
  }
});

export default makeStyles(styles);
